var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path5, _path6, _path7, _ellipse7, _ellipse8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFoundPage404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 418,
    viewBox: "0 0 408 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.89,
    cy: 43.4018,
    rx: 61.0177,
    ry: 33.25,
    transform: "rotate(10.0647 222.89 43.4018)",
    fill: "#FBD7F4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.759,
    cy: 18.5764,
    rx: 13.356,
    ry: 3.4616,
    transform: "rotate(-18.7764 185.759 18.5764)",
    fill: "white",
    fillOpacity: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 117L244.5 135.697L296 402H103L160.5 117Z",
    fill: "url(#paint0_linear_5079_2038)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.788 324.826H93.8516V351.081H57.6699V324.826H3.58301V297.922L59.9893 215.447H93.8516V297.458H108.788V324.826ZM57.6699 297.458V281.687C57.6699 278.718 57.7627 274.729 57.9482 269.719C58.1956 264.647 58.3812 261.988 58.5049 261.74H57.4844C55.3815 266.503 53.0003 270.956 50.3408 275.1L35.3115 297.458H57.6699Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M246.443 270.571C252.654 293.751 253.325 311.788 248.456 324.682C243.571 337.517 233.123 346.079 217.112 350.369C201.46 354.563 188.156 352.109 177.201 343.007C166.23 333.844 157.767 318.151 151.812 295.928C145.569 272.628 144.874 254.502 149.727 241.548C154.58 228.594 165.012 219.972 181.023 215.682C196.616 211.504 209.905 214.026 220.892 223.248C231.923 232.394 240.44 248.168 246.443 270.571ZM187.03 286.491C191 301.307 194.655 311.245 197.996 316.304C201.337 321.364 205.188 323.31 209.549 322.141C213.97 320.957 216.308 317.257 216.563 311.041C216.879 304.81 215.099 294.465 211.225 280.008C207.335 265.491 203.688 255.583 200.283 250.284C196.863 244.926 192.972 242.831 188.611 243.999C184.25 245.168 181.895 248.808 181.548 254.92C181.201 261.032 183.028 271.556 187.03 286.491Z",
    fill: "#9E007E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M404.788 324.745H389.852V351H353.67V324.745H299.583V297.841L355.989 215.365H389.852V297.377H404.788V324.745ZM353.67 297.377V281.605C353.67 278.637 353.763 274.647 353.948 269.638C354.196 264.566 354.381 261.907 354.505 261.659H353.484C351.382 266.422 349 270.875 346.341 275.019L331.312 297.377H353.67Z",
    fill: "#333333"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.242,
    cy: 79.521,
    rx: 126.613,
    ry: 39.7256,
    transform: "rotate(12.6661 217.242 79.521)",
    fill: "#DC8ECD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.744,
    cy: 88.539,
    rx: 113.053,
    ry: 31.1899,
    transform: "rotate(12.6661 216.744 88.539)",
    fill: "#9E007E"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.812,
    cy: 113.302,
    rx: 53.114,
    ry: 23.0441,
    transform: "rotate(10.0647 205.812 113.302)",
    fill: "#DC8ECD"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.77,
    cy: 122.608,
    rx: 44.3304,
    ry: 14.1289,
    transform: "rotate(10.0647 203.77 122.608)",
    fill: "url(#paint1_linear_5079_2038)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.492 158.768C171.595 158.492 171.858 158.309 172.154 158.309C172.449 158.309 172.712 158.492 172.815 158.768C173.055 159.416 173.3 160.079 173.438 160.452C173.51 160.647 173.662 160.797 173.855 160.87C174.228 161.009 174.891 161.252 175.539 161.492C175.815 161.595 176 161.858 176 162.154C176 162.449 175.815 162.714 175.539 162.815C174.891 163.055 174.228 163.3 173.855 163.438C173.662 163.51 173.51 163.662 173.438 163.855C173.3 164.228 173.055 164.891 172.815 165.539C172.712 165.815 172.449 166 172.154 166C171.858 166 171.595 165.815 171.492 165.539C171.252 164.891 171.007 164.228 170.869 163.855C170.797 163.662 170.645 163.51 170.452 163.438C170.079 163.3 169.416 163.055 168.768 162.815C168.492 162.714 168.309 162.449 168.309 162.154C168.309 161.858 168.492 161.595 168.768 161.492C169.416 161.252 170.079 161.009 170.452 160.87C170.645 160.797 170.797 160.647 170.869 160.452C171.007 160.079 171.252 159.416 171.492 158.768Z",
    fill: "#9E007E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.183 194.459C233.286 194.183 233.549 194 233.845 194C234.14 194 234.403 194.183 234.506 194.459C234.746 195.107 234.991 195.77 235.129 196.143C235.201 196.338 235.353 196.488 235.546 196.56C235.919 196.7 236.582 196.943 237.23 197.183C237.506 197.286 237.691 197.549 237.691 197.845C237.691 198.14 237.506 198.405 237.23 198.506C236.582 198.746 235.919 198.991 235.546 199.129C235.353 199.201 235.201 199.353 235.129 199.546C234.991 199.919 234.746 200.582 234.506 201.23C234.403 201.506 234.14 201.691 233.845 201.691C233.549 201.691 233.286 201.506 233.183 201.23C232.943 200.582 232.698 199.919 232.56 199.546C232.488 199.353 232.336 199.201 232.143 199.129C231.77 198.991 231.107 198.746 230.459 198.506C230.183 198.405 230 198.14 230 197.845C230 197.549 230.183 197.286 230.459 197.183C231.107 196.943 231.77 196.7 232.143 196.56C232.336 196.488 232.488 196.338 232.56 196.143C232.698 195.77 232.943 195.107 233.183 194.459Z",
    fill: "#9E007E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.183 332.459C131.286 332.183 131.549 332 131.845 332C132.14 332 132.403 332.183 132.506 332.459C132.746 333.107 132.991 333.77 133.129 334.143C133.201 334.338 133.353 334.488 133.546 334.56C133.919 334.7 134.582 334.943 135.23 335.183C135.506 335.286 135.691 335.549 135.691 335.845C135.691 336.14 135.506 336.405 135.23 336.506C134.582 336.746 133.919 336.991 133.546 337.129C133.353 337.201 133.201 337.353 133.129 337.546C132.991 337.919 132.746 338.582 132.506 339.23C132.403 339.506 132.14 339.691 131.845 339.691C131.549 339.691 131.286 339.506 131.183 339.23C130.943 338.582 130.698 337.919 130.56 337.546C130.488 337.353 130.336 337.201 130.143 337.129C129.77 336.991 129.107 336.746 128.459 336.506C128.183 336.405 128 336.14 128 335.845C128 335.549 128.183 335.286 128.459 335.183C129.107 334.943 129.77 334.7 130.143 334.56C130.336 334.488 130.488 334.338 130.56 334.143C130.698 333.77 130.943 333.107 131.183 332.459Z",
    fill: "#9E007E"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 199.5,
    cy: 382.5,
    rx: 63.5,
    ry: 5.5,
    fill: "#F3D9EE"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 199.5,
    cy: 382.5,
    rx: 34.5,
    ry: 2.5,
    fill: "#DBBCD6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5079_2038",
    x1: 200,
    y1: 230.5,
    x2: 199.5,
    y2: 402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5079_2038",
    x1: 199.302,
    y1: 139.034,
    x2: 199.442,
    y2: 105.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCFF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundPage404);
export default __webpack_public_path__ + "static/media/notFoundPage--404.b8e9b8ae2c4a3fe3e7231343daca00a4.svg";
export { ForwardRef as ReactComponent };